'use strict';
module.exports = function calculateScale(options, bounds) {
	const padding = (options && options.padding) || 0,
		scaleFromOptions = (options && options.scale),
		scaleForBounds = scaleFromOptions || 1,
		maxPage = options && options.maxPage,
		exceedsMaxPage = maxPage && ((bounds.width * scaleForBounds > maxPage.width) || (bounds.height * scaleForBounds > maxPage.height)),
		page = (options && options.page) || (exceedsMaxPage && maxPage),
		scaleFromPage = page && (Math.min((page.width - 2 * padding) / bounds.width, (page.height - 2 * padding) / bounds.height)),
		finalScale = scaleFromPage || scaleFromOptions || 1,
		roundedToTwo = Math.floor(100 * finalScale) / 100;
	return roundedToTwo;
};


